module.exports = __webpack_public_path__ + "img/union-play.f41d93ee.svg";